import { useIntl } from 'react-intl';
import { Queue } from '@rossum/api-client/queues';
import { RulePage, RulePageProps } from '../../../rules/rule-detail/RulePage';
import { QueueSettingsBreadcrumbs } from '../../components/QueueSettingsBreadcrumbs';

export const CreateRulePage = ({
  queue,
  parentPath,
  workspaceName,
}: Omit<RulePageProps, 'renderBreadcrumbs'> & {
  queue: Queue;
  workspaceName: string;
}) => {
  const intl = useIntl();

  return (
    <RulePage
      queue={queue}
      parentPath={parentPath}
      renderBreadcrumbs={breadcrumbs => (
        <QueueSettingsBreadcrumbs
          breadcrumbs={[
            {
              label: intl.formatMessage({
                id: 'features.queueSettings.rules.list.title',
              }),
              to: `${parentPath}/rules`,
            },
            ...breadcrumbs,
          ]}
          queue={queue}
          workspaceName={workspaceName}
        />
      )}
    />
  );
};
